import ENV from "config/Env";
import { backendQueryKey } from "hooks/useTypedQuery";

import type { CheckInService, Tag } from "models";

const component = "CheckInServices";

export const CheckInServicesQueryKeys = {
  dealerList: backendQueryKey<CheckInService[]>({ component, baseUrl: ENV.appointmentBaseURL, endpoint: "/check_in/service/list" }),
  locationList: backendQueryKey<CheckInService[]>({ component, baseUrl: ENV.appointmentBaseURL, endpoint: "/check_in/service/location_list" }),
  tags: backendQueryKey<Tag[]>({ component, baseUrl: ENV.systemBaseURL, endpoint: "/tags/list" })
};
